import checkAccess from "./checkAccess";

const users = JSON.parse(localStorage.getItem("zaffa-admin"));

let isAdmin = false;
let hasDataManagement = false;

let dataManageArray = [
  "country",
  "language",
  "currency",
  "culture",
  "employment",
  "hobby",
  "personality",
  "relationship",
  "sect",
  "chat_report_reason",
  "user_report_reason",
  "malicious_words",
  "user_plans",
  "delete_reason",
  "block_reason",
];

if (users && typeof users === "object") {
  const useArray = Object.values(users);
  const adminUser = useArray?.find((user) => user?.role === "Super Admin");

  if (adminUser) {
    isAdmin = false;
  }
} else if (users?.role === "Super Admin") {
  isAdmin = false;
}

dataManageArray.forEach((item) => {
  if (checkAccess(`read_${item}`)) {
    hasDataManagement = true;
  }
});

export const MENU_SIDEBAR = [
  { title: "Dashboard", path: "/dashboard", id: "skip", action: "read" },
  { title: "Users", path: "/users", id: "users", action: "read" },
  {
    title: "Announcements",
    path: "/announcement",
    id: "announcement",
    action: "read",
  },
  {
    title: "Malicious Reports",
    path: "/malicious-reports",
    id: "malicious_reports",
    action: "read",
  },
  ...(hasDataManagement
    ? [
        {
          title: "Data Management",
          children: [
            {
              title: "Country",
              path: "/data-management/country",
              action: "read",
              id: "country",
            },
            {
              title: "Language",
              path: "/data-management/language",
              action: "read",
              id: "language",
            },
            {
              title: "Currency",
              path: "/data-management/currency",
              action: "read",
              id: "currency",
            },
            {
              title: "Culture",
              path: "/data-management/culture",
              action: "read",
              id: "culture",
            },
            {
              title: "Employment",
              path: "/data-management/employment",
              action: "read",
              id: "employment",
            },
            {
              title: "Hobby",
              path: "/data-management/hobby",
              action: "read",
              id: "hobby",
            },
            {
              title: "Personality",
              path: "/data-management/personality",
              action: "read",
              id: "personality",
            },
            {
              title: "Relationship",
              path: "/data-management/relationship",
              action: "read",
              id: "relationship",
            },
            {
              title: "Sect",
              path: "/data-management/sect",
              action: "read",
              id: "sect",
            },
            {
              title: "Chat Report Reason",
              path: "/data-management/report-reason",
              action: "read",
              id: "chat_report_reason",
            },
            {
              title: "User Report Reason",
              path: "/data-management/user-report-reason",
              action: "read",
              id: "user_report_reason",
            },
            {
              title: "Malicious Words",
              path: "/data-management/malicious-words",
              action: "read",
              id: "malicious_words",
            },
            {
              title: "User Plans",
              path: "/data-management/user-plans",
              action: "read",
              id: "user_plans",
            },
            {
              title: "Delete Reason",
              path: "/data-management/delete-reason",
              action: "read",
              id: "delete_reason",
            },
            {
              title: "Block Reason",
              path: "/data-management/block-reason",
              action: "read",
              id: "block_reason",
            },
          ],
          action: "read",
          id: "skip",
        },
      ]
    : []),
  {
    title: "Subscription History",
    path: "/subscription-history",
    id: "subscription_history",
    action: "read",
  },
  ...(isAdmin
    ? [
        {
          title: "Members & Roles",
          children: [
            {
              title: "Roles",
              path: "/access-management/roles",
              id: "skip",
              action: "read",
            },
            {
              title: "Permissions",
              path: "/access-management/permission",
              id: "skip",
              action: "read",
            },
            {
              title: "Team Members",
              path: "/access-management/team-members",
              id: "skip",
              action: "read",
            },
          ],
          action: "read",
          id: "skip",
        },
      ]
    : []),
];
